import React from 'react'
import mongodblogo from "../../mongodblogo.png"

const MongoDB = () => {
    return (
        <div style={{minHeight: 120}}>
            <div className="card card-body" style={{width: 300}}>
                <article >
                    <img  src={mongodblogo} alt=""/>
                </article>
                Some placeholder content for the collapse component. This panel is hidden by default but revealed when the user activates the relevant trigger.
            </div>
        </div>
    )
}

export default MongoDB
